<template>
  <div>
    <b-container v-if="isLoading" class= "loader-section">
      <frontoffice-loader/>
    </b-container>

    <div v-else class="container-fluid events">
      <page-title>
        {{ $t('event.title') }}
      </page-title>

      <!-- <div class="toggle-link" @click="animateChevron" v-if="isViewPortMobile"> -->
      <div class="toggle-link" @click="animateChevron">
        <a @click="isShownFilters = !isShownFilters">
          <span class="">
            {{ $t('_filter.list') }}
          </span>
          <span :class="animate"><i class="fas fa-chevron-down"></i></span>
        </a>

      <div class="container">
        <div class="row" v-show="isShownFilters">
          <b-form class="col-xl-9 form-inline">
            <div class="filter-date filter">
               <date-input class="from"
                label="date de début"
                placeholder="date de début"
                name="from"
                ref="from"
                v-model="filter.startDate"
              />
            </div>

            <div class="filter-date filter">
              <date-input class="to"
                label="date de fin"
                placeholder="date de fin"
                name="to"
                ref="to"
                v-model="filter.endDate"
              />
            </div>

            <div class="filter-city filter">
              <label class="label">{{ $t('_city') |lowercase }}</label>
              <b-input id="inlineFormInputCity" v-model="filter.city"  v-on:keyup.enter="listEvents"/>
            </div>
          </b-form>

          <div class="col-xl-3 text-center filters-buttons">
            <!-- <b-row class="justify-content-around justify-content-md-start"> -->
              <input type="button" class="btn orange-white"
                           :value="$t('_validate')"
                           name="filter"
                           v-on:click="listEvents"
              />
              <input type="button" class="btn orange-white"
                           :value="$t('_reset')"
                           name="reset"
                           v-on:click="resetFilters"
              />
          <!-- </b-row> -->
        </div>
        </div> <!-- filters-row -->
      </div>
      </div>
      <b-row>
        <b-col class="map-link">
          <a @click="isShownMap = !isShownMap">
            <span><i class="fas fa-map-marked-alt"></i></span>

            <span>{{ isShownMap ? $t('_hide_map') : $t('_show_map') }}</span>
          </a>
        </b-col>
      </b-row>

      <b-row>
        <b-col sm="12" lg="4" class="map" v-show="isShownMap">
          <h3>
            {{ $t('event.map.localisation') }}
          </h3>

          <l-map
            style="height: 500px;"
            ref="eventsmap"
            :zoom="leaflet.zoom"
            :center="leaflet.center"
            :options="leaflet.options"
            class="eventsMap"
          >
            <l-tile-layer
              :url="leaflet.url"
              :attribution="leaflet.attribution"
            />
          </l-map>
        </b-col>

        <b-col sm="12" :lg="setLgTable" class="list-table">
          <h3>
            {{ $t('event.list.page_title') }}
          </h3>

          <div v-if="isViewPortMobile">
            <b-table  striped hover
                      :items="items"
                      :fields="fieldsMvp"
                      :busy="isLoading"
                      :class="oneSelected ? 'colored-first-tr' : ''"
                      selectable
                      select-mode="single"
                      selectedVariant="success"
                      @row-selected="openMarkerPopup"
              >
              <template slot="show_details" slot-scope="row">
                <button @click="row.toggleDetails" class="toggle">
                  <i v-if="row.detailsShowing" class="fas fa-minus"></i>
                  <i  v-else class="fas fa-plus"></i>
                </button>
              </template>

              <template slot="row-details" slot-scope="row">
                <b-row>
                  <b-col sm="12" class="detailCell-wrapper">
                    <p>{{$t('_ending_date')}}</p>
                    <p>{{ formatDate(row.item.ending_date) }}</p>
                  </b-col>

                  <b-col sm="12" class="detailCell-wrapper">
                    <p>{{$t('_city')}} :</p>
                    <p>{{ row.item.city }}</p>
                  </b-col>

                  <b-col v-if="row.item.location"
                         sm="12" class="detailCell-wrapper"
                  >
                    <p>{{$tc('location.default', 1)}} :</p>
                    <p>{{ row.item.location }}</p>
                  </b-col>
                </b-row>
              </template>

              <template slot="starting_date" slot-scope="data">
                {{ formatDate(data.value) }}
              </template>
            </b-table>
          </div>

          <div v-if="isViewPortDesktop">
            <b-table
              striped hover
              :items="items"
              :fields="fieldsDvp"
              :busy="isLoading"
              :class="oneSelected ? 'colored-first-tr' : ''"
              selectable
              select-mode="single"
              selectedVariant="success"
              @row-selected="openMarkerPopup"
            >
              <!-- A custom formatted column -->
              <template slot="starting_date" slot-scope="data">
                {{ formatDate(data.value) }}
              </template>

              <template slot="ending_date" slot-scope="data">
                {{ formatDate(data.value) }}
              </template>
            </b-table>
          </div>

          <div v-if="items.length === 0" class="notfound">
            {{$t('event.no_event')}}
          </div>
        </b-col>
      </b-row>
    </div>
  </div>

</template>

<script>
import CommonApi from '@/api/commonApi'
import pageTitle from '@/components/frontoffice/pageTitle'
import frontofficeLoader from '@/components/frontoffice/loader'
import { getFrontOfficeHelperStyle } from '@/utils/style'
import viewPort from '@/conf/viewPort'
import formatter from '@/components/global/mixins/formatterMethods'
import submitButton from '@/components/frontoffice/form/baseInput/submit'
import dateInput from '@/components/frontoffice/form/baseInput/date'

import { defaultLeaflet } from '@/conf/leaflet'
import { L, LMap, LMarker, LTileLayer } from 'vue2-leaflet'
import 'leaflet/dist/leaflet.css'

export default {
  components: {
    pageTitle,
    frontofficeLoader,
    LMap,
    LTileLayer,
    LMarker,
    submitButton,
    dateInput
  },

  mixins: [formatter, viewPort],

  data () {
    return {
      animate: 'down',
      hotelBackground: true,
      leaflet: defaultLeaflet,
      fieldsMvp: [
        'show_details',
        { key: 'name', sortable: true, label: 'nom du salon' },
        { key: 'starting_date', sortable: true, label: 'date de début' }
      ],
      items: [{ _showDetails: true }],
      fieldsDvp: [
        { key: 'name', sortable: true, label: 'nom du salon' },
        { key: 'starting_date', sortable: true, label: 'date de début' },
        { key: 'ending_date', sortable: true, label: 'date de fin' },
        { key: 'city', sortable: true, label: 'ville' },
        { key: 'location', sortable: true, label: 'lieu' }
      ],
      isLoading: false,
      markers: [],
      commonApi: new CommonApi(),
      isShownFilters: false,
      isShownMap: false,
      filter: {
        startDate: null,
        endDate: null,
        city: ''
      },
      oneSelected: false
    }
  },

  methods: {
    resetFilters () {
      this.filter.startDate = null
      this.filter.endDate = null
      this.filter.city = ''
      this.listEvents()
    },

    listEvents () {
      this.isLoading = true
      this.commonApi.listEvents(this.filter).then(response => {
        this.isLoading = false
        this.items = response.data.data
        this.$nextTick(() => {
          this.updateMap()
        })
      }).catch(function (error) {
        // errors already catched by axios interceptor => @/views/frontoffice/home.vue
        // this.items = []
      })
    },

    openMarkerPopup (event) {
      event = event[0]

      if (event) {
        let marker = this.markers.find(function (marker) {
          return marker._leaflet_id === event.markerLeafletId
        })

        // Open a marker popup automatically closes all others, but it does not happen if the event is not related to a marker
        this.markers.forEach(function (marker) {
          marker.closePopup()
        })

        // Uncolor previous selected line
        this.oneSelected = false

        if (marker) {
          marker.openPopup()
        }
      }
    },

    updateMap () {
      // remove current markers
      for (let marker of this.markers) {
        marker.remove()
      }
      this.markers = []

      // Create new markers
      let items = this.items

      for (let item of items) {
        if (item.geo_lat && item.geo_lng) {
          let latlng = L.latLng(item.geo_lat, item.geo_lng)
          let marker = new L.Marker(latlng, { draggable: false })

          marker.addTo(this.$refs.eventsmap.mapObject)
          marker.bindPopup(item.name)
          marker.on('click', function (event) {
            let eventToPrepend = null

            for (let i in items) {
              if (items.hasOwnProperty(i)) {
                let evt = items[i]
                evt.selected = false

                if (evt.id === item.id) {
                  eventToPrepend = items.splice(i, 1)[0]
                  eventToPrepend.selected = true
                  break
                }
              }
            }

            items.unshift(eventToPrepend)
          })

          item.markerLeafletId = marker._leaflet_id

          this.markers.push(marker)
        }
      }

      // recompute center and zoom
      if (this.markers.length) {
        let group = new L.featureGroup(this.markers)
        this.$refs.eventsmap.mapObject.fitBounds(group.getBounds(), { padding: [10, 10] })
      }
    },

    animateChevron () {
      if (this.animate === 'down') {
        return this.animate = 'up'
      } else {
        return this.animate = 'down'
      }
    }
  },

  computed: {
    wrapperClass () {
      return this.hotelBackground ? 'hotel-background' : ''
    },

    contentClass () {
      return this.hotelBackground ? 'has-background' : ''
    },

    backgroundImageStyle () {
      return getFrontOfficeHelperStyle(this.hotelBackground)
    },

    formClass () {
      return this.displayGrid ? 'grid' : ''
    },
    setLgTable: function() {
      if(this.isShownMap){
        return "8"
      }else{
        return "12"
      }
    },
  },

  created () {
    this.listEvents()
    if (this.isViewPortDesktop) {
      this.isShownFilters = this.isShownMap = true
    }
  },

  watch: {
    items: function (events) {
      for (let i in events) {
        if (events.hasOwnProperty(i)) {
          if (events[i].selected) {
            this.oneSelected = true
          }
        }
      }

      // Being in here means either that page is loading or a marker has been clicked
      // So we can remove table-success class of all elements within the table
      let classToRemove = 'table-success'

      if (this.oneSelected) {
        let all = document.getElementsByClassName(classToRemove)

        for (var i = 0; i < all.length; i++) {
          all[i].classList.remove(classToRemove)
        }
      }
    },

    isViewPortDesktop (val) {
      this.isShownFilters = this.isShownMap = val
    }
  }
}
</script>

<style lang="scss">
  @import '@/assets/sass/common/color.scss';

  .selected {
    background-color: rgba(230, 80, 17, 0.1); // $orange with 0.1 opacity
  }

  .leaflet-pane {
    &.leaflet-popup-pane {
      .leaflet-popup-content-wrapper {
        color: $orange;
        font-weight: bold;
      }

      .leaflet-popup-close-button {
        color: #1A2050; // $blue
      }
    }
  }

  table {
    .b-table-row-selected.table-success { /* TODO: not working */
      background-color: rgba(230, 80, 17, 0.1) !important; // $orange with 0.1 opacity
    }

    &.colored-first-tr {
      tbody {
        tr:first-of-type {
          background-color: rgba(230, 80, 17, 0.1) !important; // $orange with 0.1 opacity
        }
      }
    }
  }
</style>
